<app-text class="text">{{ name() }}</app-text>
